import React, { useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch } from 'react-redux';
import { setAccountOption } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import { cpfCnpjMask } from '../../../../../../../../utils/masks';

function SetClientSearch() {
  const dispatch = useDispatch();
  const [client, setClient] = useState('');

  const changeValue = (newValue: string) => {
    let valueInput = newValue;
    // permite letras alem de numeros para aceitar CNPJ alfanumerico;
    // qualquer outro caractere e rejeitado
    const regex = /[^A-Z0-9]/;

    valueInput = valueInput
      .replaceAll('.', '')
      .replaceAll('-', '')
      .replaceAll('/', '')
      .toUpperCase();

    if (regex.test(valueInput)) {
      setClient(client);
    }

    if (!regex.test(valueInput)) {
      if (valueInput.length !== 11 && valueInput.length !== 14)
        setClient(valueInput);
      else setClient(cpfCnpjMask(valueInput)!);
    }

    dispatch(setAccountOption(valueInput));
  };

  return (
    <Wrapper.Default flexDirection="row" isActive>
      <span>Cliente:</span>
      <Form.Control
        type="text"
        placeholder="Conta OU CPF/CNPJ"
        value={client}
        onChange={(event) => changeValue(event.target.value)}
        style={{ width: '12rem', margin: '0 1rem 0 0.25rem' }}
      />
    </Wrapper.Default>
  );
}

export default SetClientSearch;
